import React, { useState } from "react";
import { xor } from "lodash";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import {
  FilterButtonList,
  FilterDropdownContent,
  FilterEmpty,
  FilterFooter,
  FilterTextArea,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Link } from "@sonder/ui/source/styled/fragments/Link";
import { useSegment } from "analytics/segment";
import { setFilters } from "schedule/actions";
import { useStore } from "schedule/store";
import { cleaningRequestCategoryToLabel } from "schedule/utils/scheduleUtils";
import { CleaningRequestCategory } from "typings/globalGQLTypes";

export const CleanTypeFilters = () => {
  const { track } = useSegment();
  const {
    state: { filters },
    dispatch,
  } = useStore();

  const { cleaningRequestCategory: selectedCleanTypes } = filters;

  const [searchTerm, setSearchTerm] = useState("");
  const cleanTypeKeyValues = Object.entries(cleaningRequestCategoryToLabel).map(
    ([key, value]) => {
      return { key, value };
    },
  );

  const filteredCleanTypeKeyValues = cleanTypeKeyValues.filter(cleanType => {
    return cleanType.value
      .toLowerCase()
      .includes(searchTerm.toLocaleLowerCase());
  }) as { key: CleaningRequestCategory; value: string }[];

  const totalSelected = selectedCleanTypes?.length ?? 0;

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Clean Types
          {totalSelected > 0 && ` (${totalSelected})`}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen }) =>
        isPortalOpen && (
          <FilterDropdownContent align="center">
            <FilterTextArea
              autoFocus
              placeholder="Search clean types"
              value={searchTerm}
              onChange={e => {
                setSearchTerm(e.target.value);
              }}
            />

            {filteredCleanTypeKeyValues.length === 0 ? (
              <FilterEmpty>{`No Results for ${searchTerm}.`}</FilterEmpty>
            ) : (
              <FilterButtonList>
                {filteredCleanTypeKeyValues.map(cleanType => {
                  return (
                    <CheckboxDropdownItem
                      checked={selectedCleanTypes?.includes(cleanType.key)}
                      key={cleanType.key}
                      onClick={() => {
                        const newSelectedCleanTypes = xor(selectedCleanTypes, [
                          cleanType.key,
                        ]);
                        track({
                          eventName: "clean_type_filters",
                          action: "click",
                          element: "select_clean_type",
                          props: {
                            cleaningRequestCategory: newSelectedCleanTypes,
                          },
                        });
                        dispatch(
                          setFilters({
                            cleaningRequestCategory: newSelectedCleanTypes,
                          }),
                        );
                      }}
                    >
                      {cleanType.value}
                    </CheckboxDropdownItem>
                  );
                })}
              </FilterButtonList>
            )}

            <FilterFooter>
              {`${totalSelected || 0} Selected`}
              {totalSelected > 0 && (
                <Link
                  onClick={() => {
                    track({
                      eventName: "clean_type_filters",
                      action: "click",
                      element: "clear_clean_types",
                    });
                    requestAnimationFrame(() =>
                      dispatch(setFilters({ cleaningRequestCategory: [] })),
                    );
                  }}
                >
                  Clear selected
                </Link>
              )}
            </FilterFooter>
          </FilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
